import styled from 'styled-components';

import Button from '@adsk/alloy-react-button';
import { MagnifyingGlassIcon } from '@adsk/alloy-react-icon';

export const StyledSearchFilterPanelFooter = styled.div`
  padding: 16px;
`;

export const StyledSearchButton = styled(Button).attrs({
  variant: Button.VARIANTS.PRIMARY,
  renderIcon: MagnifyingGlassIcon.renderIcon,
})`
  width: 100%;
`;
